import { storage } from "../storageconstants";

const ENDPOINT = "/analytics/event";

function buildFormData(eventName, extras) {
  const formData = new FormData();
  formData.append("event", eventName);

  const sessionId = sessionStorage.getItem(storage.SESSION) || "";
  if (sessionId) {
    formData.append("session", sessionId);
    formData.append("checkout_session_id", sessionId);
  }
  formData.append("page", typeof window !== "undefined" ? window.location.pathname : "");
  formData.append(
    "viewport",
    typeof window !== "undefined" ? `${window.innerWidth}x${window.innerHeight}` : ""
  );

  if (extras) {
    for (const [k, v] of Object.entries(extras)) {
      if (v == null || v === "") continue;
      formData.append(k, Array.isArray(v) ? v.join(",") : String(v));
    }
  }
  return formData;
}

// Best-effort emit. Mirrors AnalyticsController: sendBeacon first (survives
// page-unload-ish transitions like the wallet modal opening), fetch+keepalive
// fallback. Never throws — telemetry must not break the checkout UX.
export function emitCheckoutEvent(eventName, extras = {}) {
  try {
    const formData = buildFormData(eventName, extras);
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      if (navigator.sendBeacon(ENDPOINT, formData)) return;
    }
    fetch(ENDPOINT, { method: "POST", body: formData, keepalive: true }).catch(() => {});
  } catch (_) {
    /* swallow */
  }
}
